import { FleetTypeSlug } from '@jucy/rentals-common';
import FleetCategoryAvailability from './api/model/FleetCategoryAvailability';

export const isStarFleetType = (fleetCat: FleetCategoryAvailability): boolean => fleetCat.fleetType?.slug === FleetTypeSlug.motorhome;
